import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';

var Application = require("expose-loader?Application!./main.js");
import './styles/index.less';